export default "__VITE_ASSET__BzVqXKTN__"